export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/logo.svg?dfa25b22cdb9dbcf50ce8101e13fb686";